import { account_capabilityService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, account_capability: []};

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        account_capabilityService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        account_capabilityService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/accounts');
                    dispatch('alert/success', "Data Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/accounts');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  account_capability: state => {
    return state.account_capability
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.account_capability = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.account_capability = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const account_capabilities = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
